<script setup lang="ts">
import SubCardHeading from "../SubCardHeading.vue";
import { ModelType } from "@/features/BuildingProject";
import ModelCard from "./ModelCard.vue";

const props = defineProps<{
  models: Array<ModelType>;
}>();

const emit = defineEmits<{
  toggleModel: [model: ModelType];
  removeModel: [model: ModelType];
}>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <SubCardHeading class="t-small-bold text-type-default">Selected models ({{ props.models.length }})</SubCardHeading>
    <p
      v-if="props.models.length === 0"
      class="t-small text-type-muted">
      No models included yet. Turn one on or create one below.
    </p>
    <ul
      v-else
      class="flex flex-wrap gap-2">
      <li
        v-for="model in props.models"
        :key="model.name">
        <ModelCard
          :model="model"
          @toggle="emit('toggleModel', $event)"
          @remove="emit('removeModel', $event)" />
      </li>
    </ul>
  </div>
</template>
